export enum LunarCalendarType {
    Japanese = 0,
    Chinese,
    Korean,
}
